// src/pages/container_rental/components/StatusChip.tsx
//
// 계약 상태 칩 — 한글 단독 라벨.
//
// 구 매니페스트의 "스텐실 야드 태그"(각진 박스 · mono 대문자 코드 + 한글 병기 ·
// hazard 빗금 펄스)를 걷어내고, 확정 디자인 시스템의 소프트 칩으로 교체했다.
//  · radius 6 / 미세 보더 / 옅은 틴트 배경
//  · 상태 의미색은 그대로 유지(steel=진행, amber=경고, stop=오류, 중립=초안·종료)
//  · 라벨은 한글 단독, 본문 서체(IBM Plex Sans KR)

import { Box } from "@mui/material";
import { designTokens } from "../../../theme.ts";
import { RentalStatus } from "../../../contracts/container_rental/types.ts";

const T = designTokens;

interface StatusChipProps {
  status: RentalStatus;
  size?: "small" | "medium";
  sx?: any;
}

/** 의미색 유지 — 도트는 원색, 배경/텍스트는 같은 계열의 틴트/딥 톤. */
const STATUS_CONF: Record<
  RentalStatus,
  { ko: string; bg: string; fg: string; dot: string; border: string }
> = {
  draft:     { ko: "초안",     bg: "#F2F4F5", fg: "#4A5057", dot: "#9AA0A6", border: "#E4E7EA" },
  active:    { ko: "진행중",   bg: "#E6F0F2", fg: "#0B4A59", dot: T.steel,   border: "#CFE1E6" },
  paused:    { ko: "일시정지", bg: "#FCF3E4", fg: "#8A5C12", dot: T.amber,   border: "#F1E0C2" },
  closed:    { ko: "종료",     bg: "#FFFFFF", fg: "#6B7178", dot: "#9AA0A6", border: "#E4E7EA" },
  cancelled: { ko: "취소",     bg: "#FBEDED", fg: T.stop,    dot: T.stop,    border: "#F0D6D6" },
};

export default function StatusChip({ status, size = "small", sx }: StatusChipProps) {
  const conf = STATUS_CONF[status] ?? STATUS_CONF.draft;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        height: size === "small" ? 22 : 26,
        px: 0.85,
        borderRadius: "6px",
        border: `1px solid ${conf.border}`,
        bgcolor: conf.bg,
        color: conf.fg,
        fontFamily: T.fonts.sans,
        fontWeight: 600,
        fontSize: size === "small" ? 11.5 : 12.5,
        lineHeight: 1,
        letterSpacing: 0,
        whiteSpace: "nowrap",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: conf.dot,
          flexShrink: 0,
        }}
      />
      {conf.ko}
    </Box>
  );
}
